module.exports = __webpack_public_path__ + "img/swap-mid.924d2a63.svg";